import { render, staticRenderFns } from "./chat-attached-document.vue?vue&type=template&id=608e486b&scoped=true"
import script from "./chat-attached-document.vue?vue&type=script&lang=js"
export * from "./chat-attached-document.vue?vue&type=script&lang=js"
import style0 from "./chat-attached-document.vue?vue&type=style&index=0&id=608e486b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e486b",
  null
  
)

export default component.exports